import { render, staticRenderFns } from "./Footer.vue?vue&type=template&id=e0a478da&scoped=true&"
var script = {}
import style0 from "./Footer.vue?vue&type=style&index=0&id=e0a478da&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0a478da",
  null
  
)

export default component.exports